/** @format */

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../api/api";

// Centralisation des routes API
const API_ROUTES = {
  ADD_FRIEND: "/api/chat/customer/add_customer_friend",
  SEND_MESSAGE: "/api/chat/customer/send_message",
};

// Fonction utilitaire pour la gestion des messages d'erreur
const getErrorMessage = (error) =>
  error.response?.data.message || error.message;

// Action pour ajouter un ami
export const add_friend = createAsyncThunk(
  "chat/add_friend",
  async (info, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.post(API_ROUTES.ADD_FRIEND, info, {
        withCredentials: true,
      });
      //console.log("Info utilisateur friend :", data);
      return fulfillWithValue(data);
    } catch (error) {
      //console.error("Erreur lors de d'ajout d'un ami : ", error);
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

export const send_message = createAsyncThunk(
  "chat/send_message",

  async (info, { rejectWithValue, fulfillWithValue }) => {
    //console.log('info', info)
    try {
      const { data } = await api.post(API_ROUTES.SEND_MESSAGE, info, {
        withCredentials: true,
      });
      //console.log("Info utilisateur message :", data);
      return fulfillWithValue(data);
    } catch (error) {
      //console.error("Erreur lors de l'envoi d'un message : ", error);
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

// Reducer principal
export const chatReducer = createSlice({
  name: "chat",
  initialState: {
    successMessage: "",
    messageError: "",
    loader: false,
    myFriends: [],
    fd_messages: [],
    fd_messages_success: "",
    currentFriend: {},
    unreadPerSeller: {},
    totalCustommerUnread: 0,
    activeCustomer: [],
    activeSeller: [],
  },
  reducers: {
    setChatInfo: (state, action) => {
      state.chatInfo = action.payload;
    },
    messageClear: (state) => {
      state.messageError = "";
      state.successMessage = "";
      state.fd_messages_success = "";
    },
    updateCustomer: (state, action) => {
      console.log(" updateCustomer", action.payload);
      state.activeCustomer = action.payload;
    },
    updateSeller: (state, action) => {
      console.log("updateSeller", action.payload);

      state.activeSeller = Array.isArray(action.payload) ? action.payload : [];
    },
    updateMessage: (state, action) => {
      state.fd_messages = [...state.fd_messages, action.payload];
    },

    // Incrementer le badge quand un message arrive (conv non ouverte)
    incrementUnread: (state, action) => {
      const { sellerId } = action.payload;

      // unreadPerSeller est un tableau [{ _id, count }]
      if (Array.isArray(state.unreadPerSeller)) {
        const existing = state.unreadPerSeller.find((u) => u._id === sellerId);
        if (existing) {
          existing.count += 1;
        } else {
          state.unreadPerSeller.push({ _id: sellerId, count: 1 });
        }
        state.totalCustommerUnread = state.unreadPerSeller.reduce(
          (acc, u) => acc + (u.count || 0),
          0,
        );
      }
    },

    // Remettre a zero le compteur d'un seller specifique
    clearUnreadForSeller: (state, action) => {
      const sellerId = action.payload;

      if (Array.isArray(state.unreadPerSeller)) {
        state.unreadPerSeller = state.unreadPerSeller.map((u) =>
          u._id === sellerId ? { ...u, count: 0 } : u,
        );
        state.totalCustommerUnread = state.unreadPerSeller.reduce(
          (acc, u) => acc + (u.count || 0),
          0,
        );
      }
    },

    // Marquer les messages RECUS d'un seller comme seen (customer a ouvert la conv)
    markAllSeen: (state, action) => {
      const { sellerId } = action.payload;
      state.fd_messages = state.fd_messages.map((m) =>
        m.senderId === sellerId && m.status === "unseen"
          ? { ...m, status: "seen" }
          : m,
      );
    },

    // Marquer les messages ENVOYES comme seen (le seller les a lus)
    markOutgoingAsSeen: (state, action) => {
      const { sellerId } = action.payload;
      state.fd_messages = state.fd_messages.map((m) =>
        m.receiverId === sellerId && m.status === "unseen"
          ? { ...m, status: "seen" }
          : m,
      );
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(add_friend.pending, (state) => {
        state.loader = true;
        state.messageError = "";
      })
      .addCase(add_friend.fulfilled, (state, action) => {
        state.loader = false;
        state.successMessage = action.payload.message;
        state.myFriends = action.payload.myFriends;
        state.currentFriend = action.payload.currentFriend;
        state.fd_messages = action.payload.messages;

        state.unreadPerSeller = action.payload.unreadPerSeller;
        state.totalCustommerUnread = action.payload.totalCustommerUnread;
      })
      .addCase(add_friend.rejected, (state, action) => {
        state.loader = false;
        state.messageError = action.payload.message;
      })
      .addCase(send_message.pending, (state) => {
        state.loader = true;
        state.messageError = "";
      })

      .addCase(send_message.fulfilled, (state, action) => {
        const myMessage = action.payload?.data;

        if (myMessage && myMessage.receiverId) {
          let tempFriends = state.myFriends || [];

          let friendIndex = tempFriends.findIndex(
            (friend) => friend.fdId === myMessage.receiverId,
          );

          while (friendIndex > 0) {
            let friend = tempFriends[friendIndex];
            tempFriends[friendIndex] = tempFriends[friendIndex - 1];
            tempFriends[friendIndex - 1] = friend;
            friendIndex--;
          }

          state.fd_messages = [...(state.fd_messages || []), myMessage];

          state.fd_messages_success =
            action.payload?.message || "Message sent successfully";
        } else {
          console.warn("Invalid payload:", action.payload);
        }

        state.loader = false;
      });
  },
});

export const {
  setChatInfo,
  messageClear,
  updateMessage,
  updateCustomer,
  updateSeller,
  markOutgoingAsSeen,
  markAllSeen,
  incrementUnread,
  clearUnreadForSeller,
} = chatReducer.actions;
export default chatReducer.reducer;
